import { createWebHistory, createRouter } from "vue-router";

import PaymentMain from "@/pages/external-payment/PaymentMain"
import MerchantPayment from "@/pages/external-payment/MerchantPayment"
import PaymentSuccess from "@/pages/external-payment/PaymentSuccess"
import PaymentFailed from "@/pages/external-payment/PaymentFailed"
import PaymentMethod from "@/pages/external-payment/PaymentMethod"
import VpSdkSetup from "@/pages/external-payment/vp-sdk-setup/VpSdkSetup";

const routes = [
    // web routes
    {
        name: 'payment',
        // path: '/merchant-payment-form',
        path: '/',
        component: PaymentMain,
        children: [
            {
                name: 'merchant-payment',
                path: 'merchant-payment-form',
                component: MerchantPayment
            },
            {
                name: 'payment-success',
                path: 'payment-method/success',
                component: PaymentSuccess
            },
            {
                name: 'payment-failed',
                path: 'payment-method/error',
                component: PaymentFailed
            },
            {
                name: 'payment-method',
                path: 'payment-method',
                component: PaymentMethod
            },
            {
                name: 'vp-sdk-setup',
                path: 'vp-sdk-setup',
                component: VpSdkSetup
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes // short for `routes: routes`
});


export default router;
